import { getOSSymbolInfo } from "@/canv/utils";
import type { MenuItemsList } from "@/interface/ContextMenu/types";
import { decodeHtml } from "@/shared/lib/decodeHtml";

const ACTION_SYMBOL = decodeHtml(getOSSymbolInfo().actionSymbol);
const SUBMENU_SYMBOL = decodeHtml(`&#62`);
const DELETE_SYMBOL = decodeHtml(`&#9003;`);

export const OFFSET = 10;
export const PADDING_SUBMENU = 16;
export const WIDGET_MENU_PADDING = 4;

export const ARRANGE_SUB_MENU = [
    { label: "Левый край", name: "alignLeft", shortCut: "" },
    {
        label: "Центры горизонтально",
        name: "alignHCenters",
        shortCut: "",
    },
    { label: "Правый край", name: "alignRight", shortCut: "" },
    { label: "Верхний край", name: "alignTop", shortCut: "" },
    {
        label: "Центры вертикально",
        name: "alignVCenters",
        shortCut: "",
    },
    { label: "Нижний край", name: "alignBottom", shortCut: "" },
];
export const MENU_ITEMS_LIST: MenuItemsList = [
    { id: 1, name: "copy", label: "Скопировать", shortCut: `${ACTION_SYMBOL} C` },
    { id: 2, name: "paste", label: "Вставить", shortCut: `${ACTION_SYMBOL} V` },
    { id: 3, name: "duplicate", label: "Дублировать", shortCut: `${ACTION_SYMBOL} D` },
    { id: 4, name: "lock", label: "Заблокировать" },
    { id: 5, name: "unlock", label: "Разблокировать" },
    { id: 6, name: "comment", label: "Комментировать", shortCut: "C" },
    { id: 7, name: "divider", label: "" },
    { id: 8, name: "toFront", label: "Перенести вперед", shortCut: `${ACTION_SYMBOL} ]` },
    { id: 9, name: "toBack", label: "Перенести назад", shortCut: `${ACTION_SYMBOL} [` },
    {
        id: 10,
        name: "arrange",
        label: "Выровнять",
        shortCut: SUBMENU_SYMBOL,
        submenu: ARRANGE_SUB_MENU,
    },
    { id: 11, name: "divider", label: "" },
    { id: 12, name: "undo", label: "Шаг назад", shortCut: `${ACTION_SYMBOL} + Z` },
    { id: 13, name: "redo", label: "Шаг вперед", shortCut: `${ACTION_SYMBOL} + Shift + Z` },
    { id: 14, name: "divider", label: "" },
    { id: 15, name: "copyAsPng", label: "Скопировать как PNG" },
    { id: 16, name: "export", label: "Экспортировать" },
    { id: 17, name: "linkToWidget", label: "Скопировать ссылку" },
    { id: 18, name: "divider", label: "" },
    { id: 19, name: "delete", label: "Удалить", shortCut: DELETE_SYMBOL },
    { id: 20, name: "addSticker", label: "Добавить стикер", shortCut: "N" },
    { id: 21, name: "addText", label: "Добавить текст", shortCut: "T" },
    { id: 22, name: "addShape", label: "Добавить фигуру", shortCut: "S" },
];
